<button class="search-toggle" (click)="toggle()">
    <svg-icon src="/assets/icons/search.svg"></svg-icon>
</button>
<div class="search-box" [class.active]="isOpened">
    <input *ngIf="isOpened" type="text" placeholder="Search" (keydown.enter)="apply()" [(ngModel)]="filter.name" />
    <svg-icon class="clear" src="/assets/icons/cross-thing.svg" (click)="toggle()"></svg-icon>
</div>